import { useState } from "react";

export function usePopup() {
  const [popup, setPopup] = useState({
    add: false,
    edit: false,
    delete: false,
    default: false
  });

  const openPopup = (type) => {
    setPopup((prev) => ({ ...prev, [type]: true }));
  };

  const closePopup = (type) => {
    return () => setPopup((prev) => ({ ...prev, [type]: false }));
  };

  return { popup, openPopup, closePopup };
}
